<template>
  <div class="width-100 container min-height flex-column justify-content-spaceBetween align-items-center">
    <div class="width-100 margin-b">
      <van-form @submit="onSubmit">
        <div class="br-reg margin-b bg-white br-mid padding-Tb-10 van-overflow-hidden">
          <van-field
            readonly
            clickable
            :value="form.defendantDeptName"
            label="被举报单位"
            placeholder="请选择被举报单位"
            @click="showPicker = true"
            :rules="[{ required: true }]"
          />
          <van-popup v-model="showPicker" position="bottom" round>
            <van-picker show-toolbar :columns="reportDeptArr" @confirm="onConfirm" @cancel="showPicker = false" />
          </van-popup>
          <!--          <van-field name="radio" label="单选框" :rules="[{ required: true }]">
            <template #input>
              <van-radio-group v-model="form.ifRealName" checked-color="rgb(235, 76, 72)" direction="horizontal">
                <van-radio name="1">实名</van-radio>
                <van-radio name="2">匿名</van-radio>
              </van-radio-group>
            </template>
          </van-field>-->
          <van-field
            v-model="form.reportUserName"
            label="举报人姓名"
            placeholder="请填写举报人姓名"
            :rules="[{ required: true }]"
            v-if="anonymous == '1'"
          />
          <van-field
            v-model="form.reportUserMobile"
            label="联系电话"
            placeholder="请填写联系电话"
            :rules="[{ validator: mobileValidator, message: '请填写正确的手机号码' }]"
            v-if="anonymous == '1'"
          />
          <van-field name="uploader" label="文件上传">
            <template #input>
              <van-uploader v-model="picture" multiple :after-read="afterRead" />
            </template>
          </van-field>
        </div>
        <div class="br-reg bg-white br-mid padding-Tb-20 van-overflow-hidden">
          <p class="black padding-lr fs-mid">举报内容</p>
          <van-field
            v-model="form.reportContent"
            rows="3"
            autosize
            label=""
            type="textarea"
            placeholder="请填写举报内容"
            :rules="[{ required: true }]"
          />
        </div>
        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit" color="linear-gradient(to top, #EC524B, #FF7B3F)" size="normal">提交</van-button>
        </div>
      </van-form>
    </div>
    <p class="black textAlign-c margin-t">{{ config.lk }}</p>
  </div>
</template>
<script>
import { config, deptList, imageUpload, save } from '@/api/msxcApi';
import { Toast } from 'vant';

export default {
  name: 'msxcForm',
  data() {
    return {
      config: {},
      anonymous: 1,
      form: {
        defendantDeptId: '',
        reportUserName: '',
        reportUserMobile: '',
        files: '',
        reportContent: ''
      },
      reportDeptArr: [],
      picture: [],
      showPicker: false
    };
  },
  created() {
    this.anonymous = this.$route.query.ay;
    config().then((res) => {
      this.config = res.data;
    });
    deptList({ state: 'use' }).then((res) => {
      this.createDeptList(res.data);
      /*res.data.forEach((item) => {
        if (item.parentId !== 0) {
          let obj = {};
          obj.id = item.id;
          obj.text = item.name;
          this.reportDeptArr.push(obj);
        }
      });*/
    });
  },
  methods: {
    createDeptList(data) {
      let parentArr = [];
      data.forEach((item) => {
        if (item.parentId === 0) {
          let obj = {};
          obj.id = item.id;
          obj.text = item.name;
          obj.children = [];

          if (item.id !== 1) {
            let cobj = {};
            cobj.id = item.id;
            cobj.text = item.name;
            obj.children.push(cobj);
          }

          parentArr.push(obj);
        }
      });
      data.forEach((item) => {
        if (item.parentId !== 0) {
          parentArr.forEach((parent) => {
            if (parent.id === item.parentId) {
              let obj = {};
              obj.id = item.id;
              obj.text = item.name;
              parent.children.push(obj);
            }
          });
        }
      });
      this.reportDeptArr = parentArr;
    },
    mobileValidator(val) {
      return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(val);
    },
    onSubmit() {
      this.form.files = '';
      this.picture.forEach((item) => {
        let imgUrl = item.file ? item.file.url : item.url;
        if (this.form.files === '') {
          this.form.files += imgUrl;
        } else {
          this.form.files += ',' + imgUrl;
        }
      });
      save(this.form).then((res) => {
        if (res.code === 200) {
          Toast.success('提交成功');
          this.$router.back();
        } else {
          Toast.fail('提交失败');
        }
      });
    },

    onConfirm(value, index) {
      this.form.defendantDeptId = this.reportDeptArr[index[0]].children[index[1]].id;
      this.form.defendantDeptName = value[1];
      this.showPicker = false;
    },

    afterRead(file) {
      let formData = new FormData();
      if (file.constructor != Array) {
        formData.append('files', file.file);
      } else {
        file.forEach((element) => {
          formData.append('files', element.file);
        });
      }
      imageUpload(formData).then((res) => {
        if (res.code === 200) {
          if (file.constructor != Array) {
            file.file.url = res.urls;
          } else {
            let urlArr = res.urls.split(',');
            let nameArr = res.originalFilenames.split(',');
            file.forEach((element) => {
              for (let i = 0; i < nameArr.length; i++) {
                if (element.file.name === nameArr[i]) {
                  element.file.url = urlArr[i];
                  break;
                }
              }
            });
          }
        } else {
          Toast('图片添加失败');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/css/common.css';
@import '../../assets/css/demo1.css';
@import '../../assets/css/demo2.css';
.container {
  background: url('../../assets/image/msxc/bg2.jpg') #f7f7f7 no-repeat;
  background-size: 100%;
  padding: 110px 5% 20px;
  /deep/.van-field__label {
    span {
      font-weight: bold;
      color: #333333;
    }
  }
  /deep/.van-radio__icon {
    font-size: 1rem;
  }
}
</style>
